import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';

import { LoginService } from '../services/login-service/login.service';
import { ContactOnboardingDataService } from '../../modules/contact-onboarding/services/contact-onboarding-data.service';
import { ROUTER_CONSTANTS } from '../constants/router.constants';

/**
 * Guards the contact-onboarding route:
 * - Sends already onboarded employees straight to Case Management.
 * - Redirects to login when there is no stored employee profile
 *   (e.g. the route was opened directly without authenticating first).
 * @returns boolean or UrlTree redirect
 */
export const ContactOnboardingGuard: CanMatchFn = (): boolean | UrlTree => {
  const loginService = inject(LoginService);
  const contactOnboardingDataService = inject(ContactOnboardingDataService);
  const router = inject(Router);

  if (loginService.isLoggedIn) {
    return router.createUrlTree([ROUTER_CONSTANTS.dashboard]);
  }

  if (!contactOnboardingDataService.hasEmployeeData()) {
    return router.createUrlTree([ROUTER_CONSTANTS.login]);
  }

  return true;
};
